import React from "react";
import AcceptInvitationForm from "../../components/AcceptInvitationForm/AcceptInvitationForm";

const Invitation = () => (
    <div>
        <AcceptInvitationForm />
    </div>
);
export default Invitation;
